var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-sample-status-data',{staticClass:"pt-sample-detail__page",attrs:{"id":_vm.id,"status":_vm.status}})
}
var staticRenderFns = []

export { render, staticRenderFns }